import React from "react";
import { useFormContext } from "react-hook-form";
import InputArea from "../../../common/components/FormFields/InputArea";

export default function ANCSurgicalHistory(props) {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });

  return (
    <div>
      <div className="flex justify-between bg-[#D9D9D9] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">
          Medical/ Surgical History
        </p>
        <div className="flex my-auto"></div>
      </div>
      <div className="w-full p-2 border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
       
          <InputArea
            control={control}
            label="Medical/ Surgical History"
            name="surgicalHistory"
          />
      
      </div>
    </div>
  );
}
